import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/status-report`;

export const statusReportsRoutes = {
  'statusReports.storage':       `${prefix}/storage`,
  'statusReports.project':      (pId=':projectId') => `${prefix}/project/${pId}`,
};
